import { useMemo } from 'react';
import type { ItemFiltersType } from '@/lib/api/types/itemFilters';
import type { Item } from '@/lib/api/types/items';
import { useItemsBulkFetchQuery } from '../common/useGetItemsBulkFetchQuery';

const EMPTY_ITEMS: Item[] = [];

export type ViewItemsQueryResult = {
  items: Item[];
  isLoading: boolean;
  isError: boolean;
  isPending: boolean;
  error: Error | null;
};

export const useViewItemsQuery = ({
  viewId,
  itemIds,
  enabled = true,
  filter,
}: {
  viewId?: number;
  itemIds: number[];
  enabled?: boolean;
  filter?: ItemFiltersType | undefined;
}) => {
  const staleTime = 5 * 60 * 1000; // 5 minutes
  const { data, isLoading, error, isError, isPending } = useItemsBulkFetchQuery(
    {
      itemIds,
      viewId,
      filter,
    },
    staleTime,
    enabled,
  );

  return useMemo(() => {
    return {
      items: data || EMPTY_ITEMS,
      isLoading,
      isError,
      isPending,
      error,
    };
  }, [data, isLoading, isError, isPending, error]);
};
